import React from 'react';
import { useNavigate } from 'react-router-dom';
import ConstructionIcon from '@mui/icons-material/Construction';
import { Box, Typography, Button } from '@mui/material';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 100px)',
        textAlign: 'center',
        padding: '20px',
        gap: 2
      }}
    >
      <ConstructionIcon 
        sx={{ 
          fontSize: 80,
          color: '#007bff',
          animation: 'pulse 2s infinite',
          '@keyframes pulse': {
            '0%': {
              transform: 'scale(1)',
            },
            '50%': {
              transform: 'scale(1.1)',
            },
            '100%': {
              transform: 'scale(1)',
            },
          }
        }}
      />
      <Typography 
        variant="h4" 
        component="h1" 
        sx={{ 
          fontWeight: 'bold',
          color: '#333',
          mb: 2
        }}
      >
        Bu sayfa geliştirilmektedir
      </Typography>
      <Button
        variant="contained"
        onClick={() => navigate('/dashboard')}
        sx={{
          backgroundColor: '#007bff',
          '&:hover': {
            backgroundColor: '#0056b3',
          },
          transition: 'background-color 0.2s',
          padding: '10px 20px',
          fontSize: '1rem',
          textTransform: 'none'
        }}
      >
        Ana Sayfaya Dön
      </Button>
    </Box>
  );
};

export default NotFoundPage; 